import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';
import Footer from '../components/Footer';
import { useCart } from '../context/CartContext';
import { usePageTracking } from '../hooks/usePageTracking';
import whiteShirt from '../assets/sambasWhiteShirt.png';
import blackShirt from '../assets/sambasBlackShirt.png';
import './Apparel.css';

const SHIRTS = [
  { id: 'white', name: 'Sambas – White Tee', color: 'White', image: whiteShirt },
  { id: 'black', name: 'Sambas – Black Tee', color: 'Black', image: blackShirt },
];

const SIZES = ['S', 'M', 'L', 'XL'];

function Apparel() {
  usePageTracking('apparel');
  const navigate = useNavigate();
  const { addToCart } = useCart();
  
  const [selectedShirt, setSelectedShirt] = useState(null);
  const [selectedSize, setSelectedSize] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [addedToCart, setAddedToCart] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleShirtClick = (shirt) => {
    setSelectedShirt(shirt);
    setSelectedSize('');
    setQuantity(1);
    setAddedToCart(false);
  };

  const handleClose = () => {
    setSelectedShirt(null);
  };

  const handleAddToCart = () => {
    if (!selectedSize) {
      alert('Please select a size.');
      return;
    }

    for (let i = 0; i < quantity; i++) {
      addToCart({
        id: `apparel-${selectedShirt.id}-${selectedSize}`,
        product: selectedShirt.name,
        size: selectedSize,
        packKey: `${selectedShirt.color}-${selectedSize}`,
        packLabel: `${selectedShirt.color} / ${selectedSize}`,
        price: 15,
      });
    }

    setAddedToCart(true);
    setTimeout(() => setAddedToCart(false), 2000);
  };

  return (
    <div className="apparel-page">
      <BrandLogo />

      <button className="apparel-back-btn" onClick={() => navigate('/')}>
        <span className="apparel-back-text">← Back</span>
        <span className="apparel-back-arrow">←</span>
      </button>

      <div className="apparel-container">
        <div className="free-shipping-banner">
          <span>Free shipping on orders over $50!</span>
        </div>

        <div className="apparel-content">
          {/* Shirt Cards Grid */}
          <div className="shirt-grid">
            {SHIRTS.map((shirt) => (
              <div key={shirt.id} className="shirt-item">
                <div
                  className="shirt-card"
                  onClick={() => handleShirtClick(shirt)}
                >
                  <div className="shirt-card-image">
                    <img src={shirt.image} alt={shirt.name} />
                  </div>
                </div>
                <span className="shirt-name">{shirt.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Product Detail Modal */}
      {selectedShirt && (
        <div className="product-modal-overlay" onClick={handleClose}>
          <div className="product-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleClose}>×</button>
            
            <div className="modal-image">
              <img src={selectedShirt.image} alt={selectedShirt.name} />
            </div>

            <div className="modal-details">
              <h1>{selectedShirt.name}</h1>
              
              <div className="modal-price">
                <span className="price-old">$20</span>
                <span className="price-new">$15</span>
              </div>

              <div className="size-section">
                <span className="size-label">Size</span>
                <div className="size-buttons">
                  {SIZES.map((size) => (
                    <button
                      key={size}
                      className={`size-btn ${selectedSize === size ? 'active' : ''}`}
                      onClick={() => setSelectedSize(size)}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>

              <div className="cart-row">
                <div className="quantity-box">
                  <button onClick={() => setQuantity(q => Math.max(1, q - 1))}>−</button>
                  <span>{quantity}</span>
                  <button onClick={() => setQuantity(q => q + 1)}>+</button>
                </div>
                <button 
                  className={`add-cart-btn ${addedToCart ? 'success' : ''}`}
                  onClick={handleAddToCart}
                  disabled={!selectedSize}
                >
                  {addedToCart ? '✓ ADDED!' : 'ADD TO CART'}
                </button>
              </div>

              <div className="modal-detail-section">
                <h3>Detail</h3>
                <p>Premium streetwear performance tee. Comfortable fit for everyday wear. 100% cotton, pre-shrunk fabric.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default Apparel;
